export default __webpack_public_path__ + "static/media/exit.ca516e28.svg";